<template>
  <v-form
    :disabled="form.processing"
    @submit.prevent="submit"
  >
    <v-card>
      <v-card-title>{{ $t('Change password') }}</v-card-title>
      <v-card-subtitle>{{ $t('Update your current password') }}</v-card-subtitle>
      <v-card-text>
        <v-text-field
          v-model="form.current_password"
          :label="$t('Current password')"
          :loading="form.processing"
          :disabled="form.processing"
          :error-messages="form.errors.current_password"
          autocomplete="new-password"
          outlined
          type="password"
        />

        <password-input
          v-model="form.new_password"
          :label="$t('New password')"
          outlined
          :loading="form.processing"
          :disabled="form.processing"
          :error-messages="form.errors.new_password"
        />

        <v-text-field
          v-model="form.new_password_confirmation"
          :loading="form.processing"
          :disabled="form.processing"
          autocomplete="new-password"
          :label="$t('Confirm new password')"
          outlined
          type="password"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          type="submit"
          color="primary"
          :loading="form.processing"
          :disabled="form.processing"
        >
          {{ $t('Update password') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import PasswordInput from '../shared/PasswordInput.vue';
export default {
  components: { PasswordInput },

  data() {
    return {
      form: this.$inertia.form('UpdatePassword', {
        current_password: '',
        new_password: '',
        new_password_confirmation: ''
      })
    }
  },

  methods: {
    submit() {
      const url = this.route('user-password.update');
      this.form.patch(url);
    }
  }
}
</script>